module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_hairmake-69e02967fbbdb497eb3cfe39fa3bccc9.png";